import io from 'socket.io-client';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { API_URL } from '../utils/config';

// Socket.io Client (Dummy-Objekt für initiale Verwendung)
let socket = {
  on: () => {},
  off: () => {},
  emit: () => {},
  connected: false
};

let isInitialized = false;

// Socket initialisieren
export const initSocket = async () => {
  try {
    // Verhindere mehrfache Initialisierung
    if (isInitialized && socket.connected) {
      return socket;
    }

    // Token aus AsyncStorage holen
    const token = await AsyncStorage.getItem('token');
    
    if (!token) {
      return socket;
    }

    // Alte Verbindung schließen falls vorhanden
    if (socket.disconnect && typeof socket.disconnect === 'function') {
      socket.disconnect();
    }

    // Socket.io Client initialisieren
    const newSocket = io(API_URL, {
      auth: {
        token
      },
      transports: ['websocket'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    newSocket.on('connect', () => {
      isInitialized = true;
    });

    newSocket.on('disconnect', () => {
      isInitialized = false;
    });

    newSocket.on('error', (error) => {
      console.error('Socket.io Fehler:', error);
    });

    socket = newSocket;
    return socket;
  } catch (error) {
    console.error('Fehler beim Initialisieren von Socket.io:', error);
    return socket;
  }
};

// Socket-Objekt exportieren
export default socket;

